export default __webpack_public_path__ + "static/media/p13.02f2e990.jpeg";